import { httpClient } from "@services/api/httpClient";

const fetchApplicantByStatus = async (offerId: number, applicantStatus: string) => {
    const response = await httpClient.get("/offer-applicant/get-by-status", {
        params: {
            offerId,
            applicantStatus
        }
    });
    return response.data;
}

export default fetchApplicantByStatus;